export { default } from "./ClickLink";
